import gql from 'graphql-tag';

/**
 * Bản rút gọn của `productSearch` cho trang Brand: chỉ đủ để lọc, đếm và sort
 * toàn bộ SKU của phạm vi. Chi tiết card lấy sau theo trang bằng `products(ids)`.
 */
export default gql`
  query productSearchIndex($sort: [ProductSort!]!, $filter: ProductFilter, $pagination: Pagination!) {
    productSearch(sort: $sort, filter: $filter, pagination: $pagination) {
      data {
        id
        allowPurchase
        priceV2 {
          price
        }
        category {
          name
          nameLocal
          parent {
            name
          }
        }
      }
    }
  }
`;
